module.exports = __webpack_public_path__ + "346962cfe83ff4252c8f429a9b10edce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bandana-s.png
// module id = 1845
// module chunks = 0